export default {
domainInvalid: {
  siteUnavailableTitle: "เว็บไซต์ไม่พร้อมใช้งาน",
  siteUnavailableDesc: "ขณะนี้เว็บไซต์นี้ไม่พร้อมใช้งาน",
  contactAdmin: "กรุณาติดต่อผู้ดูแลระบบ",
  serverErrorTitle: "บริการไม่พร้อมใช้งาน",
  serverErrorDesc: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณาลองใหม่อีกครั้งภายหลัง",
  serverErrorTip: "ระบบจะเชื่อมต่อใหม่โดยอัตโนมัติเมื่อเซิร์ฟเวอร์กลับมาทำงาน",
  notAuthorizedTitle: "โดเมนไม่ได้รับอนุญาต",
  notAuthorizedDesc: "โดเมนปัจจุบันไม่ได้รับอนุญาตให้เข้าถึงบริการนี้",
  checking: "กำลังตรวจสอบ...",
  retry: "ลองใหม่",
  reload: "โหลดใหม่",
  reloading: "กำลังโหลดใหม่...",
  checkingDomain: "กำลังตรวจสอบโดเมน...",
  authorizedRedirecting: "โดเมนได้รับอนุญาตแล้ว กำลังเปลี่ยนเส้นทาง...",
  stillNotAuthorized: "โดเมนยังไม่ได้รับอนุญาต",
  reconnecting: "กำลังเชื่อมต่อใหม่..."
}
};
